import { useEffect, useRef, useState } from "react";
import {
  PurchaseInput,
  useRankSupplierContractsForPurchaseMutation,
  useRankSupplierContractsForPurchasesMutation,
} from "../../../graphql/generated";
import BestBuyRankingList, {
  BestBuyRankingListItem,
  BestBuyRankingListProps,
} from "./BestBuyRankingList";
import { isArray } from "lodash";

export type BestBuyRankingListContainerProps = Omit<
  BestBuyRankingListProps,
  "list" | "defaultSelected"
> & {
  purchase: PurchaseInput | PurchaseInput[];
  pinCodeOrder?: string[];
};

export default function BestBuyRankingListContainer(
  props: BestBuyRankingListContainerProps
) {
  const [rankingList, setRankingList] =
    useState<BestBuyRankingListItem[] | undefined>(undefined);

  const rankSupplierContractsForPurchaseMutation =
    useRankSupplierContractsForPurchaseMutation();
  const rankSupplierContractsForPurchases =
    useRankSupplierContractsForPurchasesMutation();

  const initialPurchaseRef = useRef(props.purchase);

  const fetchRankings = async () => {
    try {
      const rankingList = isArray(initialPurchaseRef.current)
        ? await rankSupplierContractsForPurchases.mutateAsync({
            purchases: initialPurchaseRef.current,
          })
        : await rankSupplierContractsForPurchaseMutation.mutateAsync({
            purchase: initialPurchaseRef.current,
          });
      setRankingList(
        "rankSupplierContractsForPurchase" in rankingList
          ? rankingList.rankSupplierContractsForPurchase
          : rankingList.rankSupplierContractsForPurchases
      );
    } catch (error) {
      console.error("Error fetching rankings:", error);
    }
  };

  useEffect(() => {
    fetchRankings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!rankingList) {
    return null;
  }

  return (
    <BestBuyRankingList
      {...props}
      list={rankingList}
      defaultSelected={rankingList[0]}
      loading={
        rankSupplierContractsForPurchaseMutation.isLoading ||
        rankSupplierContractsForPurchases.isLoading
      }
    />
  );
}
